const backgroundImageMaxHeightInPx = 600;
const canvas = "_35sc75bw9t";
const inputs = "_35si1mt4329";
const contextMenu = "_35scz290s9";
const background = "_35sbq16g3y";

export { background, backgroundImageMaxHeightInPx, canvas, contextMenu, inputs };
import "./organism.canvas.style.linaria.module.css";
//# sourceMappingURL=organism.canvas.style.js.map
